import { render, staticRenderFns } from "./productSelect.vue?vue&type=template&id=53367094&"
import script from "./productSelect.vue?vue&type=script&lang=js&"
export * from "./productSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports